/**
 * Abrir una notificación: llevar a la página de lo que avisa. Lo usan la campana y el aviso en vivo,
 * para que los dos lleven al mismo lugar.
 *
 * 🪤 VA CON `useStoreNavigate`, no con `useNavigate` a secas. Las rutas del panel viven bajo
 *    `/store/<tienda>/…`; una ruta sin ese prefijo cae en la redirección genérica, que conserva el
 *    camino pero pierde la consulta (`?c=…`), y es un salto más por el que pasar.
 */
import { useCallback } from 'react';
import { useStoreNavigate } from '@/hooks/useStoreNavigate';
import { aDondeLlevaElAviso, type AvisoConDestino } from '@/lib/avisos/aDondeLlevaElAviso';

export function useAbrirAviso() {
  const navigate = useStoreNavigate();
  return useCallback((aviso: AvisoConDestino): boolean => {
    const destino = aDondeLlevaElAviso(aviso);
    if (!destino) return false;
    if (/^https?:\/\//i.test(destino)) window.open(destino, '_blank', 'noopener');
    else navigate(destino);
    return true;
  }, [navigate]);
}
